<div [hidden]="isSectionHidden$ | async">
  @if (props.editableSection) {
    <div class="pb-3 buttons">
      @if (isEditing$ | async) {
        <apm-icon
          class="me-2"
          size="md"
          icon="aa_refresh"
          [isButton]="true"
          (iconClick)="calculate()"
          matTooltip="{{ '444784' | apmTranslate }}"
        ></apm-icon>
        <apm-icon
          size="md"
          icon="aa_cancel"
          [isButton]="true"
          (iconClick)="cancel()"
          matTooltip="{{ '444763' | apmTranslate }}"
        ></apm-icon>
      } @else {
        @if (hasDatasheetMoreDetailsPermission && props.partialLoads) {
          <apm-icon
            class="me-2"
            size="md"
            icon="a_xls"
            [isButton]="true"
            (iconClick)="downloadPartialLoads()"
            matTooltip="{{ '448885' | apmTranslate }}"
          ></apm-icon>
        }
        <apm-icon
          class="me-2"
          size="md"
          icon="aa_edit"
          [isButton]="true"
          (iconClick)="edit()"
          matTooltip="{{ '444765' | apmTranslate }}"
        ></apm-icon>
        @if ({ somethingEdited: somethingEdited$ | async }; as edited) {
          <apm-icon
            class="me-2"
            size="md"
            icon="aa_confirm"
            [isButton]="true"
            [disabled]="!edited.somethingEdited"
            (iconClick)="save()"
            matTooltip="{{ '444682' | apmTranslate }}"
          ></apm-icon>
          <apm-icon
            size="md"
            icon="aa_cancel"
            [isButton]="true"
            [disabled]="!edited.somethingEdited"
            (iconClick)="revert()"
            matTooltip="{{ '444763' | apmTranslate }}"
          ></apm-icon>
        }
      }
    </div>
  }
  <ng-container #fieldComponent></ng-container>
</div>
